import React, { useEffect, useState } from 'react';

import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Backdrop from '@mui/material/Backdrop';

import useUser from '../../hook/useUser';

import {
  ModalWrapperSimple,
  ModalWrapperNormal,
  ModalContentCenterCenterSmall
} from '../customComponent/box';

const AlertMessage = (props) => {

  const {
    children,
    type,
    isOpen,
    message,
    handleClose
  } = props;

  useEffect(() => {

    if(type === 'noAction' && isOpen) {
      setTimeout(() => {
        handleClose();
      }, 2000)
    }

  }, [isOpen])

  if(type === 'noAction') {

    return (
      <Modal
        open={isOpen}
        closeAfterTransition
        BackdropComponent={Backdrop}
        onClose={handleClose}
      >
        <Fade in={isOpen}>
          <ModalWrapperSimple>{ message }</ModalWrapperSimple>
        </Fade>
      </Modal>
    )
    
  }

  return (
    <Modal
      open={isOpen}
      closeAfterTransition
      BackdropComponent={Backdrop}
      onClose={handleClose}
    >
      <Fade in={isOpen}>
        <ModalContentCenterCenterSmall>
          { children }
        </ModalContentCenterCenterSmall>
      </Fade>
    </Modal>
  )
}


export default AlertMessage;